/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import { useEffect, useState } from "react"
import { Table } from "react-bootstrap"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../.."
import ComboBox from "../../../../components/ComboBox"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import TextInput from "../../../../components/InputWrapper/TextInput"
import RequiredMark from "../../../../components/RequiredMark"
import CONSTANT from "../../../../constant"
import { 区分分類コード } from "../../../../constant/enum/codes"
import {
  syaryoMasterActions,
  TSyaryoMasterState,
} from "../../../../globalStore/pageStore/syaryoMaster/syaryoMasterStore"
import {
  TEtcCardData,
  TKyuyuCardData,
  TSyasaiData,
} from "../../../../globalStore/pageStore/syaryoMaster/syasaiData"
import { RootState } from "../../../../globalStore/rootreducer"
import KubunService from "../../../../service/master/kubun/kubunService"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../../type/wijmoComponents"
import "../../SyaryoMasterList/App.scss"
import dayjs from "dayjs"

//React/Redux
import { DataChangeAction } from "@grapecity/wijmo.grid.immutable"
import { ImmutabilityProvider } from "@grapecity/wijmo.react.grid.immutable"

// immutable
import {
  copyObject,
  DataChangeEventArgs,
} from "@grapecity/wijmo.grid.immutable"
import dateUtil from "../../../../ts/util/dateUtil"

export type T給油カード明細 = TKyuyuCardData & {
  給油カード発行日: Date
  給油カード有効日: Date
}

export type T車載データ明細 = TSyasaiData & {
  取付日: Date
}

/**
 * 車輌マスタ登録 車載データ部
 * @returns
 */
const SyasaiDataPane: React.FC<{
  isLoadEnded: boolean
  setIsLoadEnded: React.Dispatch<React.SetStateAction<boolean>>
}> = (props) => {
  // #region [selector]
  const syaryoMaster = useSelector(
    (state: RootState) => state.page.syaryoMaster
  ) as TSyaryoMasterState
  const disPatch: AppDispatch = useDispatch()

  //#endregion

  // #region [baseMethod]

  //#endregion

  //#region [state]
  const [, setETC設置区分] = useState<T区分マスタ | null>(null)
  // ComboBoxデータ読込フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  ////#endregion

  // #region [comboboxState]
  // 区分ItemSource
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // ETC設置区分ComboBox
  const [ETC設置区分ComboBox, setETC設置区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [ETC設置区分isLoadEnded, setETC設置区分isLoadEnded] =
    useState<boolean>(false)

  const [車載装置区分データマップ, set車載装置区分データマップ] =
    useState<wjGrid.DataMap<string, string>>()
  //#endregion

  //#region [effect]
  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)

      // GridのComboBox用DataMap
      const 車載装置区分dataMap = new wjGrid.DataMap(
        区分マスタRes.data.filter(
          (d) => d.分類コード === 区分分類コード.車輌.車載装置区分
        ),
        "区分コード",
        "名称1"
      )
      set車載装置区分データマップ(車載装置区分dataMap)
    })
    setComboDataInitialized(true)
  }, [])

  // component作成後、親パネルに返却
  useEffect(() => {
    if (comboDataInitialized && ETC設置区分ComboBox) {
      props.setIsLoadEnded(true)
    }
  }, [comboDataInitialized, ETC設置区分ComboBox])

  //#endregion

  //#region [method]

  /**
   * 車載データグリッド編集イベント
   * @param s grid
   * @param e
   */
  const onSyasaiGridDataChanged = (
    s: wjrGrid.FlexGrid,
    e: DataChangeEventArgs
  ) => {
    // const syasaiItem = e.newItem as TSyasaiData
    const syasaiItem = {
      ...e.newItem,
      取付日: dateUtil.toInputDataValueToDateString(e.newItem.取付日),
    } as TSyasaiData
    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          syaryoMasterActions.add車載データテーブル({ newItem: syasaiItem })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          syaryoMasterActions.remove車載データテーブル({
            rowId: syasaiItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          syaryoMasterActions.set車載データテーブルRow({
            newItem: syasaiItem,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  /**
   * ETCカードグリッド編集イベント
   * @param s grid
   * @param e
   */
  const onEtcCardGridDataChanged = (
    s: wjrGrid.FlexGrid,
    e: DataChangeEventArgs
  ) => {
    const gridItem = {
      ...e.newItem,
      ETCカード有効年月日: dateUtil.toInputDataValueToDateString(
        e.newItem.ETCカード有効年月日
      ),
      ETCカード発行年月日: dateUtil.toInputDataValueToDateString(
        e.newItem.ETCカード発行年月日
      ),
    } as TEtcCardData
    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          syaryoMasterActions.addETCカードテーブル({ newItem: gridItem })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          syaryoMasterActions.removeETCカードテーブル({
            rowId: gridItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          syaryoMasterActions.setETCカードテーブルRow({
            newItem: gridItem,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  /**
   * 給油カードグリッド編集イベント
   * @param s grid
   * @param e
   */
  const onKyuyuCardGridDataChanged = (
    s: wjrGrid.FlexGrid,
    e: DataChangeEventArgs
  ) => {
    const gridItem = {
      ...e.newItem,
      給油カード有効日: dateUtil.toInputDataValueToDateString(
        e.newItem.給油カード有効日
      ),
      給油カード発行日: dateUtil.toInputDataValueToDateString(
        e.newItem.給油カード発行日
      ),
    } as TKyuyuCardData
    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          syaryoMasterActions.add給油カードテーブル({ newItem: gridItem })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          syaryoMasterActions.remove給油カードテーブル({
            rowId: gridItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          syaryoMasterActions.set給油カードテーブルRow({
            newItem: gridItem,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  //TODO:色変えイベント
  // gridの必須チェックおよび検索イベント
  const syasaiFormatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        // let isExistData = true
        const rowData: TSyasaiData = e.getRow().dataItem
        // const cellBinding = e.getColumn().binding

        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = rowData.削除フラグ === 1
        wjcCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)
      }
    }
  }

  const etcCardFormatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        // let isExistData = true
        const rowData: TEtcCardData = e.getRow().dataItem
        // const cellBinding = e.getColumn().binding

        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = rowData.削除フラグ === 1
        wjcCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)
      }
    }
  }

  // gridの必須チェックおよび検索イベント
  const kyuyuCardFormatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        // let isExistData = true
        const rowData: TKyuyuCardData = e.getRow().dataItem
        // const cellBinding = e.getColumn().binding

        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = rowData.削除フラグ === 1
        wjcCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)
      }
    }
  }

  //#endregion

  return (
    <>
      <div className="accordion-header">
        車載データ
        <div className="accordion-description">車載データ登録</div>
      </div>
      <div>
        <div>
          <Row>
            <Col>
              <h5>車載データ</h5>
              <div>
                <div>
                  <div>
                    {/* <Button onClick={addNew車載データ}>追加</Button> */}
                  </div>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    formatItem={syasaiFormatItemHandler}>
                    <ImmutabilityProvider
                      itemsSource={syaryoMaster.車輌車載リスト}
                      dataChanged={onSyasaiGridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="車載装置区分コード"
                      width={200}
                      dataMap={車載装置区分データマップ}
                      header="装置">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="ColumnHeader"
                        template={() => {
                          return (
                            <>
                              <span>装置</span>
                              <RequiredMark />
                            </>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="取付日"
                      width={128}
                      editor={
                        new wjcInput.InputDate(document.createElement("div"), {
                          isRequired: false,
                          format: "yyyyMMdd",
                        })
                      }
                      format="d"
                      header="取付日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TSyasaiData>
                        ) => {
                          let dDate = ""
                          if (context.item.取付日)
                            dDate = dayjs(context.item.取付日).format(
                              "YYYY/MM/DD"
                            )
                          return (
                            <>
                              <span>{dDate}</span>
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="メーカー"
                      width={200}
                      header="メーカー"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="型式"
                      width={128}
                      header="型式"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="備考"
                      width={200}
                      header="備考"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="Row_id"
                      width={80}
                      isReadOnly={true}
                      header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TSyasaiData>
                        ) => {
                          // Store反映前に削除ボタン使えないため、row_idの有無も制御に加える
                          if (!context.item.row_id) return
                          return context.item.削除フラグ !== 1 ? (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={"waiting"}
                              onClick={(e) => {
                                e.preventDefault()
                                // 削除処理
                                if (context.item.車輌車載ID) {
                                  // 削除フラグを設定する。
                                  // 対象データ行の削除フラグを変更して変数へコピーする
                                  let rowItem = Object.freeze(
                                    copyObject(
                                      {},
                                      { ...context.item, 削除フラグ: 1 }
                                    )
                                  )

                                  // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                                  disPatch(
                                    syaryoMasterActions.set車載データテーブルRow(
                                      {
                                        // row_id: context.item.row_id!,
                                        newItem: rowItem,
                                      }
                                    )
                                  )
                                } else {
                                  // PKない場合、Storeから対象データ行をRemoveする。
                                  disPatch(
                                    syaryoMasterActions.remove車載データテーブル(
                                      { rowId: context.item.row_id! }
                                    )
                                  )
                                }
                              }}>
                              削除
                            </Button>
                          ) : (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={"pending"}
                              onClick={(e) => {
                                e.preventDefault()
                                // 削除フラグを解除する
                                // 対象データ行の削除フラグを変更して変数へコピーする
                                let rowItem = Object.freeze(
                                  copyObject(
                                    {},
                                    { ...context.item, 削除フラグ: 0 }
                                  )
                                )

                                // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                                disPatch(
                                  syaryoMasterActions.set車載データテーブルRow({
                                    // row_id: context.item.row_id!,
                                    newItem: rowItem,
                                  })
                                )
                              }}>
                              解除
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div>
          <h5>標準交換(km)</h5>
          <Container className="register-form" fluid>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-10rem">標準交換距離</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            id="オイル"
                            name="オイル"
                            value={syaryoMaster.標準交換距離オイル}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set標準交換距離オイル(v)
                              )
                            }
                            placeholder="オイル"
                          />
                          <TextInput
                            id="エレメント"
                            name="エレメント"
                            value={syaryoMaster.標準交換距離エレメント}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set標準交換距離エレメント(v)
                              )
                            }
                            placeholder="エレメント"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        </div>
        <div>
          <h5>ETC</h5>
          <Container className="register-form" fluid>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-10rem">ETC</th>
                      <td>
                        <div className="input-group">
                          <ComboBox.Kubun
                            isLoadEnded={ETC設置区分isLoadEnded}
                            setIsLoadEnded={setETC設置区分isLoadEnded}
                            isAllSelect={false}
                            isRequired={false}
                            itemsSource={区分ItemSource}
                            分類コード="C0003"
                            selectedValue={syaryoMaster.ETC設置区分}
                            setSelectedValue={(v) =>
                              disPatch(syaryoMasterActions.setETC設置区分(v))
                            }
                            setSelectedItem={setETC設置区分}
                            ComboBox={ETC設置区分ComboBox}
                            setComboBox={
                              setETC設置区分ComboBox
                            }></ComboBox.Kubun>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">ETC車載器</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            id="ETC車載器メーカー"
                            name="ETC車載器メーカー"
                            value={syaryoMaster.ETC車載器メーカー}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.setETC車載器メーカー(v)
                              )
                            }
                            placeholder="車載器メーカー"
                          />
                          <TextInput
                            id="ETC車載器シリアルNO"
                            name="ETC車載器シリアルNO"
                            value={syaryoMaster.ETC車載器シリアルNO}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.setETC車載器シリアルNO(v)
                              )
                            }
                            placeholder="車載器シリアルNO"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        </div>
        <div>
          <h5>ETCカード</h5>
          <div>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
              formatItem={etcCardFormatItemHandler}>
              <ImmutabilityProvider
                itemsSource={syaryoMaster.ETCカードリスト}
                dataChanged={onEtcCardGridDataChanged}
              />
              <wjrGrid.FlexGridColumn
                binding="ETCカード番号"
                width={200}
                isRequired={true}
                header="ETCカード番号">
                <wjrGrid.FlexGridCellTemplate
                  cellType="ColumnHeader"
                  template={() => {
                    return (
                      <>
                        <span>ETCカード番号</span>
                        <RequiredMark />
                      </>
                    )
                  }}></wjrGrid.FlexGridCellTemplate>
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="ETCカード管理会社"
                width={200}
                header="ETCカード管理会社"></wjrGrid.FlexGridColumn>

              <wjrGrid.FlexGridColumn
                binding="ETCカード発行年月日"
                width={128}
                editor={
                  new wjcInput.InputDate(document.createElement("div"), {
                    isRequired: false,
                    format: "yyyyMMdd",
                  })
                }
                format="d"
                header="発行年月日">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<TEtcCardData>
                  ) => {
                    let dDate = ""
                    if (context.item.ETCカード発行年月日)
                      dDate = dayjs(context.item.ETCカード発行年月日).format(
                        "YYYY/MM/DD"
                      )
                    return (
                      <>
                        <span>{dDate}</span>
                      </>
                    )
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="ETCカード有効年月日"
                width={128}
                format="d"
                editor={
                  new wjcInput.InputDate(document.createElement("div"), {
                    isRequired: false,
                    format: "yyyyMMdd",
                  })
                }
                header="有効年月日">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<TEtcCardData>
                  ) => {
                    let dDate = ""
                    if (context.item.ETCカード有効年月日)
                      dDate = dayjs(context.item.ETCカード有効年月日).format(
                        "YYYY/MM/DD"
                      )
                    return (
                      <>
                        <span>{dDate}</span>
                      </>
                    )
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="Row_id"
                width={80}
                isReadOnly={true}
                header=" ">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<TEtcCardData>
                  ) => {
                    // Store反映前に削除ボタン使えないため、row_idの有無も制御に加える
                    if (!context.item.row_id) return
                    return context.item.削除フラグ !== 1 ? (
                      <Button
                        className="btn btn-small btn-primary move-edit-page"
                        variant={"waiting"}
                        onClick={(e) => {
                          e.preventDefault()
                          // 削除処理
                          if (context.item.車輌ETCカードID) {
                            // 削除フラグを設定する。
                            // 対象データ行の削除フラグを変更して変数へコピーする
                            let rowItem = Object.freeze(
                              copyObject({}, { ...context.item, 削除フラグ: 1 })
                            )

                            // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                            disPatch(
                              syaryoMasterActions.setETCカードテーブルRow({
                                // row_id: context.item.row_id!,
                                newItem: rowItem,
                              })
                            )
                          } else {
                            // PKない場合、Storeから対象データ行をRemoveする。
                            disPatch(
                              syaryoMasterActions.removeETCカードテーブル({
                                rowId: context.item.row_id!,
                              })
                            )
                          }
                        }}>
                        削除
                      </Button>
                    ) : (
                      <Button
                        className="btn btn-small btn-primary move-edit-page"
                        variant={"pending"}
                        onClick={(e) => {
                          e.preventDefault()
                          // 削除フラグを解除する
                          // 対象データ行の削除フラグを変更して変数へコピーする
                          let rowItem = Object.freeze(
                            copyObject({}, { ...context.item, 削除フラグ: 0 })
                          )

                          // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                          disPatch(
                            syaryoMasterActions.setETCカードテーブルRow({
                              // row_id: context.item.row_id!,
                              newItem: rowItem,
                            })
                          )
                        }}>
                        解除
                      </Button>
                    )
                  }}></wjrGrid.FlexGridCellTemplate>
              </wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
          </div>
        </div>
        <div>
          <h5>給油カード</h5>
          <div>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
              formatItem={kyuyuCardFormatItemHandler}>
              <ImmutabilityProvider
                itemsSource={syaryoMaster.給油カードリスト}
                dataChanged={onKyuyuCardGridDataChanged}
              />
              <wjrGrid.FlexGridColumn
                binding="給油カード番号"
                width={200}
                isRequired={true}
                header="給油カードNo">
                <wjrGrid.FlexGridCellTemplate
                  cellType="ColumnHeader"
                  template={() => {
                    return (
                      <>
                        <span>給油カードNo</span>
                        <RequiredMark />
                      </>
                    )
                  }}></wjrGrid.FlexGridCellTemplate>
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="給油カード発行会社"
                width={200}
                header="給油カード会社"></wjrGrid.FlexGridColumn>

              <wjrGrid.FlexGridColumn
                binding="給油カード発行日"
                width={128}
                format="d"
                editor={
                  new wjcInput.InputDate(document.createElement("div"), {
                    isRequired: false,
                    format: "yyyyMMdd",
                  })
                }
                header="発行年月日">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<TKyuyuCardData>
                  ) => {
                    let dDate = ""
                    if (context.item.給油カード発行日)
                      dDate = dayjs(context.item.給油カード発行日).format(
                        "YYYY/MM/DD"
                      )
                    return (
                      <>
                        <span>{dDate}</span>
                      </>
                    )
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="給油カード有効日"
                width={128}
                format="d"
                editor={
                  new wjcInput.InputDate(document.createElement("div"), {
                    isRequired: false,
                    format: "yyyyMMdd",
                  })
                }
                header="有効年月日">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<TKyuyuCardData>
                  ) => {
                    let dDate = ""
                    if (context.item.給油カード有効日)
                      dDate = dayjs(context.item.給油カード有効日).format(
                        "YYYY/MM/DD"
                      )
                    return (
                      <>
                        <span>{dDate}</span>
                      </>
                    )
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="Row_id"
                width={80}
                isReadOnly={true}
                header=" ">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<TKyuyuCardData>
                  ) => {
                    // Store反映前に削除ボタン使えないため、row_idの有無も制御に加える
                    if (!context.item.row_id) return
                    return context.item.削除フラグ !== 1 ? (
                      <Button
                        className="btn btn-small btn-primary move-edit-page"
                        variant={"waiting"}
                        onClick={(e) => {
                          e.preventDefault()
                          // 削除処理
                          if (context.item.車輌給油カードID) {
                            // 削除フラグを設定する。
                            // 対象データ行の削除フラグを変更して変数へコピーする
                            let rowItem = Object.freeze(
                              copyObject({}, { ...context.item, 削除フラグ: 1 })
                            )

                            // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                            disPatch(
                              syaryoMasterActions.set給油カードテーブルRow({
                                // row_id: context.item.row_id!,
                                newItem: rowItem,
                              })
                            )
                          } else {
                            // PKない場合、Storeから対象データ行をRemoveする。
                            disPatch(
                              syaryoMasterActions.remove給油カードテーブル({
                                rowId: context.item.row_id!,
                              })
                            )
                          }
                        }}>
                        削除
                      </Button>
                    ) : (
                      <Button
                        className="btn btn-small btn-primary move-edit-page"
                        variant={"pending"}
                        onClick={(e) => {
                          e.preventDefault()
                          // 削除フラグを解除する
                          // 対象データ行の削除フラグを変更して変数へコピーする
                          let rowItem = Object.freeze(
                            copyObject({}, { ...context.item, 削除フラグ: 0 })
                          )

                          // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                          disPatch(
                            syaryoMasterActions.set給油カードテーブルRow({
                              // row_id: context.item.row_id!,
                              newItem: rowItem,
                            })
                          )
                        }}>
                        解除
                      </Button>
                    )
                  }}></wjrGrid.FlexGridCellTemplate>
              </wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
          </div>
        </div>
      </div>
    </>
  )
}

export default SyasaiDataPane
